/** Exports client */
export * from '@apollo/client'

export async function GetToken(endpoint: string, api_id: string) {
  const res = await fetch(`${endpoint}/auth`, {
    method: 'POST',
    credentials: 'include',
    body: api_id,
  })

  if (res.ok) {
    console.log('is ok', res)
    const data = await res.json()
    console.log('data', data)
    return { token: data.token, expires: data.expires }
  }

  throw new Error(`Failed to get token: ${res.statusText}`)
}

export async function Logout(endpoint: string, api_id: string) {
  const res = await fetch(`${endpoint}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
    body: api_id,
  })

  if (res.ok) return

  throw new Error(`Failed to logout: ${res.statusText}`)
}
